import { Inject, Injectable, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePipe, DecimalPipe } from "@angular/common";
import { environment } from "@env/environment";
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public CLIENT = 'marketsmojo';
  public LOGIN_USER_DETAIL: any = {};
  public LOGOUT_DETAIL: any = {};
  public LOGIN_USER_CARD_DETAIL: any = {};
  
  public DEVICETYPE = "";
  public DEVICE = "";
  public DEVICEAPPVER = "";

  toasts: any;

  CLMM_LIST:any=['integrated'];
  public block_clmm_content:boolean=false;
    fromPageObject: any = {
    '/mojopro/mojostock': 'mojostock',
    '/mojopro/hidden-turnarounds': 'hidden-turnaround',
    '/mojopro/momentum-now': 'momentumnow-stocks',
    '/mojopro/reliable-performers': 'reliable-performers',
    '/mojopro/stock-of-the-week': 'stock-of-the-week',
    '/mojopro/stock-of-the-month': 'stock-of-the-month',
    '/mojo/professional': 'screener',
    '/portfolio-plus/watchlist': 'watchlist',
    '/mojo/verdict': 'verdict',
    '/mojo/switcher': 'switcher',
    '/markets_new': 'markets',
    '/mojopro/result-corner-landing': 'earnings',
    '/mojo/resultcorner': 'resultcorner'
  }
  constructor(private _cookie: CookieService) {}

  public getCLMMCookie() {
    this.block_clmm_content=false;
    let co= this._cookie.get('__CLMM');
    if(co && this.CLMM_LIST.includes(co)) {
        this.block_clmm_content=true;
    }
    return this.block_clmm_content;
  }
  public getVal(o: any, key: any, def: any = "") {
    if (typeof key == "undefined" || typeof o == "undefined") {
      return def;
    } else if (typeof def == "undefined") {
      return "";
    } else {
      var temp = o;
      let key1 = key.split(".");
      for (var i in key1) {
        if (typeof temp[key1[i]] == "undefined") {
          return def;
        } else {
          temp = temp[key1[i]];
        }
      }
      return temp;
    }
  }
  getAppType() {
    var useragent = window.navigator.userAgent.toLowerCase();
    let r = "other";
    if (
      (useragent.indexOf("mm-app-v3.0") > -1) ||
      (useragent.indexOf("mm-app-v3.1") > -1) ||
      (useragent.indexOf("mm-app-v3.2") > -1)
    ) {
      var iOS = /ios/.test(navigator.userAgent || "");
      if (iOS == true) {
        r = "iosapp";
      } else {
        r = "other";
      }
    } else if (
      (useragent.indexOf("mm-app;vn:v3.0") > -1) ||
      (useragent.indexOf("mm-app;vn:v3.1") > -1) ||
      (useragent.indexOf("mm-app;vn:v3.2") > -1)
    ) {
      var android = /android/.test(navigator.userAgent || "");
      if (android == true) {
        r = "androidapp";
      } else {
        r = "other";
      }
    }
    return r;
  }
  getDevicep() {
    var useragent = window.navigator.userAgent.toLowerCase();
    if (useragent.indexOf("mm-app") > -1) {
      return "app";
    } else if (useragent.indexOf("mobile") > -1) {
      return "mobile";
    } else {
      return "desktop";
    }
  }
  getAppVersion() {
    var useragent = window.navigator.userAgent.toLowerCase();
    let r = "other";
    if (useragent.indexOf("mm-app-v3.0") > -1) {
      var iOS = /ios/.test(navigator.userAgent || "");
      if (iOS == true) {
        r = "iosv3.0";
      }
    } else if (
      useragent.indexOf("mm-app-v3.1") > -1 ||
      useragent.indexOf("mm-app-v3.2") > -1
    ) {
      var iOS = /ios/.test(navigator.userAgent || "");
      if (iOS == true) {
        r = "iosv3.1";
      }
    } else if (useragent.indexOf("mm-app;vn:v3.0") > -1) {
      var android = /android/.test(navigator.userAgent || "");
      if (android == true) {
        r = "androidv3.0";
      }
    } else if (
      useragent.indexOf("mm-app;vn:v3.1") > -1 ||
      useragent.indexOf("mm-app;vn:v3.2") > -1
    ) {
      var android = /android/.test(navigator.userAgent || "");
      if (android == true) {
        r = "androidv3.1";
      }
    }

    return r;
  }
  // CleverTap functionality disabled
  clevertabEventPush(name: any = '', obj: any = {}) {
    // No-op: CleverTap has been disabled
  }

  loadHotJar(){

  const hotjarScript = `(function(h,o,t,j,a,r){ 
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:3474071,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');
    r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

  const script = document.createElement('script');
  script.innerHTML = hotjarScript;
  document.head.appendChild(script);
      
  }
  getNewsCategory()
  {
      return [
        { "stocks-in-action": "Stocks in Action" },
        { "stock-recommendation": "Stock Recommendation" },
        { "result-analysis": "Result Analysis" },
        // MOSL - Removed "Across The Web" category
        // { "across-the-web": "Across The Web" },
        { "stock-market-news": "Stock Market News" },
        { "mojo-premium": "Mojo Premium" }
      ]
  }
  scoreTextName(txt = "") {
     return (txt)?txt.replace(/ /g, '').toLowerCase():'';
  }
   getFromPage(pathname: any) {
    return this.fromPageObject[pathname];
  }
  appOpenLink(baseUrl:any='',openType:any='_blank'){
    if (this.getAppType() == "iosapp") {
      (<any>window).webkit.messageHandlers.onmessage.postMessage({
        type: "openLink",
        value: baseUrl
      });
    } else if (this.getAppType() == "androidapp") {
      window.location.href =
        "https://openlink.com/?url=" +
        btoa(baseUrl);
    } else {
      window.open(baseUrl, openType);
    }
  }

}
